import { Button, Menu } from '@mantine/core';
import {
  IconBulb,
  IconCalendarMonth,
  IconCalendarPlus,
  IconChecklist,
  IconClipboardCheck,
  IconCoin,
  IconDirections,
  IconFile,
  IconHammer,
  IconPlus,
  IconUsers,
  IconWallet,
} from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { DrowdownMenuItem } from 'src/Components/NavBar/DrowdownMenuItem';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

import styles from './CreateMenu.module.scss';

const CreateMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const assetId = useCurrentAssetId();

  return (
    <div className={styles.container}>
      <Menu
        transitionProps={{ transition: 'pop-top-right' }}
        position="top-end"
        width={220}
        withinPortal
        radius="md"
      >
        <Menu.Target>
          <Button
            className={styles.button}
            leftSection={<IconPlus size={22} stroke={2} />}
            h={40}
            pl={8}
            pr={12}
            radius={8}
          >
            {t('createMenu.create', 'Créer')}
          </Button>
        </Menu.Target>
        <Menu.Dropdown>
          <DrowdownMenuItem
            label={t('createMenu.createExpense', 'Nouvelle dépense')}
            icon={<IconWallet height={22} />}
            onClick={() => {
              navigate(`/asset/${assetId}/expenses/new`);
            }}
          />
          <DrowdownMenuItem
            label={t('createMenu.createIncome', 'Nouveau revenu')}
            icon={<IconCoin height={22} />}
            onClick={() => {
              navigate(`/asset/${assetId}/expenses/new`, { state: { isIncome: true } });
            }}
          />
          <DrowdownMenuItem
            label={t('createMenu.createReservation', 'Nouvelle réservation')}
            icon={<IconCalendarPlus height={22} />}
            onClick={() => {
              navigate(`/asset/${assetId}/planning/new-event`, { state: { isReservation: true } });
            }}
          />
          <DrowdownMenuItem
            label={t('createMenu.createEvent', 'Nouvel événement')}
            icon={<IconCalendarMonth height={22} />}
            onClick={() => {
              navigate(`/asset/${assetId}/planning/new-event`);
            }}
          />
          <DrowdownMenuItem
            label={t('createMenu.createContact', 'Nouveau contact')}
            icon={<IconUsers height={22} />}
            onClick={() => {
              navigate(`/asset/${assetId}/contacts/new`);
            }}
          />
          <DrowdownMenuItem
            label={t('createMenu.createTask', 'Nouvelle tâche')}
            icon={<IconClipboardCheck height={22} />}
            onClick={() => {
              navigate(`/asset/${assetId}/tasks/new`);
            }}
          />
          <DrowdownMenuItem
            label={t('createMenu.createChecklist', 'Nouvelle checklist')}
            icon={<IconChecklist height={22} />}
            onClick={() => {
              navigate(`/asset/${assetId}/guides/checklists/new`);
            }}
          />
          <DrowdownMenuItem
            label={t('createMenu.createInstruction', 'Nouvelle consigne')}
            icon={<IconDirections height={22} />}
            onClick={() => {
              navigate(`/asset/${assetId}/guides/instructions/new`);
            }}
          />
          <DrowdownMenuItem
            label={t('createMenu.createDocument', 'Nouveau document')}
            icon={<IconFile height={22} />}
            onClick={() => {
              navigate(`/asset/${assetId}/documents`, { state: { openUpload: true } });
            }}
          />
          <DrowdownMenuItem
            label={t('createMenu.createProject', 'Nouveau projet')}
            icon={<IconHammer height={22} />}
            onClick={() => {
              navigate(`/asset/${assetId}/project-and-works/new`);
            }}
          />
          <DrowdownMenuItem
            label={t('createMenu.createIdea', 'Nouvelle idée')}
            icon={<IconBulb height={22} />}
            onClick={() => {
              navigate(`/asset/${assetId}/project-and-works/new-idea`);
            }}
          />
        </Menu.Dropdown>
      </Menu>
    </div>
  );
};

export default CreateMenu;
